import { useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config';
import { useNavigate } from 'react-router-dom';
import { showError, showSuccess } from '../utils/alerts';
import '../styles/pages/CreateCompanyPage.css';

const CreateCompanyPage = ({ token }) => {
  const [form, setForm] = useState({
    name: '',
    rut: '',
    address: '',
    rep_legal: '',
    rut_representante: '',
    comuna: '',
    ciudad: 'Santiago de Chile',
    email: '',
    phone: '',
    tipo_empresa: '',
    clave_sii: '',
    conciliacion_bancaria: ''
  });
  const [message, setMessage] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const navigate = useNavigate();

  const validatePhone = (value) => {
    if (!value.startsWith('56')) return 'El teléfono debe comenzar con 56 (ej: 56912345678)';
    if (value.length !== 11) return 'El teléfono debe tener exactamente 11 dígitos (ej: 56912345678)';
    if (!/^\d+$/.test(value)) return 'El teléfono debe contener solo números';
    return '';
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'phone') {
      setPhoneError(validatePhone(value));
    }
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const error = validatePhone(form.phone);
    if (error) {
      setPhoneError(error);
      return;
    }
    try {
      await axios.post(`${API_BASE_URL}/api/company/companies`, form, {
        headers: { Authorization: `Bearer ${token}` }
      });
      showSuccess('Empresa creada exitosamente');
      setMessage('Empresa creada exitosamente');
      navigate('/select-company');
    } catch (error) {
      console.error('Error al crear empresa:', error);

      // Mostrar mensaje específico del servidor
      const errorMessage = error.response?.data?.message || 'Error al crear empresa';

      // Si es error de límite, mostrar mensaje personalizado
      if (error.response?.status === 403) {
        showError('Has alcanzado el límite de empresas. Contacta a ventas para contratar un nuevo plan.');
      } else {
        showError(errorMessage);
      }

      setMessage(errorMessage);
    }
  };
  return (
    <div className="create-company-container">
      <h1>Crear Empresa</h1>
      <form className="create-company-form" onSubmit={handleSubmit}>
        <input name="name" value={form.name} onChange={handleChange} placeholder="Nombre de la Empresa" required />
        <input name="rut" value={form.rut} onChange={handleChange} placeholder="RUT de la Empresa" required />
        <input name="address" value={form.address} onChange={handleChange} placeholder="Dirección" required />
        <input name="comuna" value={form.comuna} onChange={handleChange} placeholder="Comuna" required />
        <input name="ciudad" value={form.ciudad} onChange={handleChange} placeholder="Ciudad" required />
        <input name="rep_legal" value={form.rep_legal} onChange={handleChange} placeholder="Nombre Representante Legal" required />
        <input name="rut_representante" value={form.rut_representante} onChange={handleChange} placeholder="RUT Representante Legal" required />
        <input name="email" type="email" value={form.email} onChange={handleChange} placeholder="Email" required />
        <input
          name="phone"
          value={form.phone}
          onChange={handleChange}
          placeholder="Teléfono (ej: 56912345678)"
          maxLength={11}
          required
        />
        {phoneError && <p className="create-company-field-error">{phoneError}</p>}
        <input
          name="clave_sii"
          type="password"
          value={form.clave_sii}
          onChange={handleChange}
          placeholder="Clave SII (para automatizar RCV)"
        />
        <select
          name="conciliacion_bancaria"
          value={form.conciliacion_bancaria}
          onChange={(e) => setForm({ ...form, conciliacion_bancaria: e.target.value })}
          required>
          <option value="" disabled>¿Conciliación Bancaria?</option>
          <option value="true">Sí</option>
          <option value="false">No</option>
        </select>
        <select
          name="tipo_empresa"
          value={form.tipo_empresa}
          onChange={handleChange}
          required>
          <option value="" disabled>Selecciona el tipo de empresa</option>
          <option value="Producto">Producto</option>
          <option value="Servicio">Servicio</option>
        </select>
        <button type="submit">Crear Empresa</button>
      </form>
      <p className="create-company-hint">
        Selecciona en tipo de empresa, la opción <strong>Servicios</strong> si tu empresa solo vende servicios de consultoría como ser contadores, abogados, arquitectos, etc., y selecciona <strong>Productos</strong> si tu empresa vende cualquier tipo de producto.
      </p>
      {message && <p>{message}</p>}
    </div>
  );
};

export default CreateCompanyPage;